// KPIs › Vision at `/c/{slug}/kpis/vision` (MEETINGS): the company's vision page, open to
// whoever may open the scorecard or the chart (`CadenceGate`); managers edit it.
import { createRoute } from "@tanstack/react-router";
import { CadenceGate } from "../features/cadence/cadence-parts";
import { VisionScreen } from "../features/cadence/vision-screen";
import { useCompany } from "../features/use-feature";
import { validateFocusSearch } from "../focus/focus";
import { kpisRoute } from "./c.$slug.kpis";

export const visionRoute = createRoute({
  getParentRoute: () => kpisRoute,
  path: "vision",
  validateSearch: (search: Record<string, unknown>) => validateFocusSearch(search),
  component: function Vision() {
    const { api } = visionRoute.useRouteContext();
    return (
      <CadenceGate what="Vision">
        <VisionScreen api={api} company={useCompany()} />
      </CadenceGate>
    );
  },
});
